export type SimilarItemsGroupsApiRow = {
    items: Array<{ itemId: number }>;
    title: string;
    viewMoreUrl: string;
};

export type SimilarItemsGroupsSlice = {
    byId: Record<number, number[]>;
    loaded: Record<number, number>;
    loading: number[];
    totalRecordsByItemId: Record<number, number>;
};

export const defaultSimilarItemsGroupsSlice: SimilarItemsGroupsSlice = {
    byId: {},
    loaded: {},
    loading: [],
    totalRecordsByItemId: {},
};

export type LoadSimilarItemsGroupsFulfilledPayload = {
    actionTime: number;
    itemId: number;
    itemIdList: number[];
    totalRecords: number;
};
